import axios from '@/axios/api.request'

export const serviceSave = (from) => axios.request({
    url: '/service/settle/save',
    data: from,
    method: 'post'
  })

  export const serviceApply = (from) => axios.request({
    url: '/service/settle/apply',
    data: from,
    method: 'post'
  })

  export const serviceEmptyApply = () => axios.request({
    url: '/service/settle/empty/apply',
    data: {},
    method: 'post'
  })

  export const pay = (from) => axios.request({
    url: '/service/settle/pay',
    data: from,
    method: 'post'
  })

  export const users = (from) => axios.request({
    url: '/service/settle/users',
    data: from,
    method: 'post'
  })

  export const serviceBack = (from) => axios.request({
    url: '/service/settle/back',
    data: from,
    method: 'post'
  })